import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Freon Editor Interfaces",
description: "Interfaces that define the extensibility and flexibility of the Freon editor framework, including projections, actions, and expressions.",
tags: [ "Editor Interfaces", "FreProjection", "FreExpression", "FreBinaryExpression", "Freon"] ,
modifiedTime: "2025-11-07T19:13:10.927Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};